<p-tabView [(activeIndex)]="activeIndex">
  <p-tabPanel class="mb-2" [disabled]="disabledInputs" header="Inputs used in calculation">
    <app-eea-output-pearl-run-inputs-use-in-calculation *ngIf="!disabledInputs" [selectedModel]="selectedModel"
      [selectedProject]="selectedProject"></app-eea-output-pearl-run-inputs-use-in-calculation>
  </p-tabPanel>
  <p-tabPanel class="mb-2" [disabled]="disabledSummary" header="Summary of the results">
    <app-eea-output-project-pearl-result-summary *ngIf="!disabledSummary"
      [selectedProject]="selectedProject" [selectedModel]="selectedModel"></app-eea-output-project-pearl-result-summary>
  </p-tabPanel>
</p-tabView>